var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid p-3"},[_vm._t("content_container")],2)}
var staticRenderFns = []

export { render, staticRenderFns }